import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import ShippingInsurancePage from '@/v2/components/pages/public-pages/shipping-insurance-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/shipping-insurance-page'

interface ShippingInsurancePageProps {}

const Page: React.FC<ShippingInsurancePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.shipping_insurance.title ?? ''}
        keywords={META_CONTENTS.shipping_insurance?.keywords ?? ''}
        description={META_CONTENTS.shipping_insurance?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <ShippingInsurancePage />
    </>
  )
}

export default Page
